<template>
  <div class="viq-gap">
    <div class="viq-gap__header">
      <h3 class="viq-gap__title">Gap Analysis</h3>
      <el-button v-if="step === 'form'" size="small" @click="goBack">Back</el-button>
    </div>

    <!-- Step 1: Form -->
    <div v-if="step === 'form'" class="viq-gap__form">
      <p class="viq-gap__desc">
        Identify compliance gaps by answering guided questions about your current state.
        VIQ will analyse your responses and provide severity ratings with remediation recommendations.
      </p>
      <el-input
        v-model="topic"
        type="textarea"
        :rows="3"
        placeholder="e.g., AML compliance for e-money institutions in the UK..."
      />
      <el-input
        v-model="jurisdiction"
        size="small"
        placeholder="Jurisdiction"
        class="viq-gap__form-field"
      />
      <div class="viq-gap__form-actions">
        <el-button type="primary" :disabled="!topic.trim()" @click="startQuestions">
          Start Assessment
        </el-button>
      </div>
    </div>

    <!-- Step 2: Questions -->
    <ViqGapQuestions
      v-else-if="step === 'questions'"
      :questions="gapQuestions"
      @submit="submitAnswers"
    />

    <!-- Step 3: Results -->
    <ViqGapResults
      v-else-if="step === 'results'"
      :results="gapResults"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ViqGapAnalysis",
  components: {
    ViqGapQuestions: () => import("./ViqGapQuestions"),
    ViqGapResults: () => import("./ViqGapResults"),
  },
  data() {
    return {
      step: "form",
      topic: "",
      jurisdiction: "",
    };
  },
  computed: {
    ...mapState("Viq", ["gapQuestions", "gapResults", "isStreaming"]),
  },
  watch: {
    gapQuestions(val) {
      if (val && val.length > 0 && !this.isStreaming) {
        this.step = "questions";
      }
    },
    gapResults(val) {
      if (val) {
        this.step = "results";
      }
    },
  },
  methods: {
    goBack() {
      this.$store.commit("Viq/SET_REPORT_STEP", 0);
      this.$store.commit("Viq/SET_REPORT_TYPE", null);
    },
    startQuestions() {
      if (!this.topic.trim()) return;
      this.$store.dispatch("Viq/streamGapQuestions", {
        topic: this.topic.trim(),
        jurisdiction: this.jurisdiction.trim() || undefined,
      });
    },
    submitAnswers(answers) {
      this.$store.dispatch("Viq/streamGapAnalysis", {
        topic: this.topic.trim(),
        jurisdiction: this.jurisdiction.trim() || undefined,
        answers,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-gap {
  max-width: 720px;
  margin: 0 auto;
  width: 100%;
  padding: $viq-space-lg 0;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: $viq-space-lg;
  }

  &__title {
    font-size: $viq-font-lg;
    font-weight: 700;
    color: $viq-text-primary;
    margin: 0;
  }

  &__desc {
    font-size: $viq-font-base;
    color: $viq-text-secondary;
    margin: 0 0 $viq-space-lg;
    line-height: 1.5;
  }

  &__form {
    padding: $viq-space-lg;
    background: $viq-bg-primary;
    border: 1px solid $viq-border;
    border-radius: $viq-radius-lg;
  }

  &__form-field {
    margin-top: $viq-space-md;
  }

  &__form-actions {
    margin-top: $viq-space-md;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
